import { render, staticRenderFns } from "./CarBrands.vue?vue&type=template&id=19e7526a&scoped=true"
import script from "./CarBrands.vue?vue&type=script&lang=js"
export * from "./CarBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e7526a",
  null
  
)

export default component.exports